/**
 * @desc 站点课程模块
 */
const webSiteCourseList = r => require.ensure([], () => r(require('../views/webSiteCourse/WebSiteCourseList.vue')), 'webSiteCourseList');

export default [
  //站点课程列表
  {
    name: 'webSiteCourseList',
    path: '/webSiteCourseList',
    component: webSiteCourseList,
    meta: { title: '首页课程模块' },
  },
]